import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { ADMIN_FORM_MODAL_PANEL } from './adminModalPanel';

/**
 * Modal abono / pago parcial (Vigencias).
 * El monto se registra en finanzas (finance_income_events).
 */
export default function PartialPaymentModal({
  open,
  saving = false,
  userName = '',
  plan = '',
  planAmount = null,
  onClose,
  onConfirm,
  t = (k, fb) => fb || k,
}) {
  const [amount, setAmount] = useState('');

  useEffect(() => {
    if (!open) return;
    setAmount('');
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' && !saving) onClose?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, saving, onClose]);

  if (!open) return null;

  const parsed = Math.round(Number(amount));
  const valid = Number.isFinite(parsed) && parsed > 0;

  const panel = (
    <div className="form-modal-overlay" role="dialog" aria-modal="true">
      <div className={`${ADMIN_FORM_MODAL_PANEL} form-modal d28d-admin-modal ui-light-panel surface-readable max-w-md w-full`}>
        <div className="flex items-start justify-between gap-3 mb-3">
          <div>
            <h3 className="text-lg font-semibold text-stone-900">
              {t('vigencias.partial_title', 'Pago parcial — registrar abono')}
            </h3>
            <p className="text-sm text-stone-600 mt-1">
              {userName || t('vigencias.partial_user', 'Usuario')}
              {plan ? ` · ${plan}` : ''}
            </p>
          </div>
          <button
            type="button"
            className="btn-secondary p-2"
            disabled={saving}
            onClick={onClose}
            aria-label={t('common.close', 'Cerrar')}
          >
            <X size={16} />
          </button>
        </div>
        <p className="text-sm text-stone-700 mb-3">
          {t(
            'vigencias.partial_hint',
            'Indica el monto abonado. Quedará en observaciones y en el módulo de Finanzas.',
          )}
        </p>
        {planAmount != null && Number(planAmount) > 0 ? (
          <p className="text-xs text-stone-500 mb-2">
            {t('vigencias.partial_plan_price', 'Precio plan')}: ${Number(planAmount).toLocaleString('es-CO')} COP
          </p>
        ) : null}
        <label className="block text-sm font-medium text-stone-800 mb-1">
          {t('vigencias.partial_amount', 'Monto abonado (COP)')}
        </label>
        <input
          type="number"
          min={1}
          step={1}
          className="input w-full mb-4"
          value={amount}
          disabled={saving}
          autoFocus
          placeholder="Ej. 50000"
          onChange={(e) => setAmount(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && valid && !saving) onConfirm?.(parsed);
          }}
        />
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-secondary" disabled={saving} onClick={onClose}>
            {t('common.cancel', 'Cancelar')}
          </button>
          <button
            type="button"
            className="btn-primary"
            disabled={!valid || saving}
            onClick={() => onConfirm?.(parsed)}
          >
            {saving
              ? t('common.saving', 'Guardando…')
              : t('vigencias.partial_save', 'Registrar abono')}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(panel, document.body);
}
